import { render, staticRenderFns } from "./AttributeInProduct.vue?vue&type=template&id=010cf9b5&scoped=true&"
import script from "./AttributeInProduct.vue?vue&type=script&lang=js&"
export * from "./AttributeInProduct.vue?vue&type=script&lang=js&"
import style0 from "./AttributeInProduct.vue?vue&type=style&index=0&id=010cf9b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010cf9b5",
  null
  
)

export default component.exports